module.exports = __webpack_public_path__ + "static/media/harvest.87a47093.svg";